import React from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';

import './App.css';


function VL2SuccessPage() {
  const { termId } = useParams();

  return (
    <main className="main-content">
      <div className="success-container">
        <div className="checkmark-circle">
          <div className="checkmark"></div>
        </div>
        <h2>Thank You!</h2>
        <p>Your RICS Home
Survey Level 2 report Terms & Conditions acceptance form has been successfully submitted.</p>
        <p>We have sent a confirmation email to the address you provided.</p>
        <p className="ref-text">Reference: <strong>{termId}</strong></p>
        <p>If you have any questions, please contact us on <strong>0800 169 9661</strong> (option 2), quoting your reference number.</p>
      </div>
    </main>
  );
}

export default VL2SuccessPage;
